import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "scroll",
  ref: "scroll$"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scroll_item = _resolveComponent("scroll-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stripeTransform, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "scroll-stripe",
        key: index,
        style: _normalizeStyle({
        paddingTop: item.paddingTop + 'px',
        transform: `translateY(${item.top}px)`,
      })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgList.filter((v, k) => (k + 1) % 3 === index), (v, index) => {
          return (_openBlock(), _createBlock(_component_scroll_item, {
            class: "scroll-item",
            key: index,
            url: v.imgUrl,
            title: v.title
          }, null, 8, ["url", "title"]))
        }), 128))
      ], 4))
    }), 128))
  ], 512))
}